export default __webpack_public_path__ + "static/media/linkedin.f1ef2c0c.svg";